import {useRef} from "react";
import {Bar} from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import {DateUtil} from "base/utilities";
import DownloadChart from "./DownloadChart";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

const whiteBackgroundPlugin = {
    id: "custom_canvas_background_color",
    beforeDraw: chart => {
        const ctx = chart.canvas.getContext("2d");
        ctx.save();
        ctx.globalCompositeOperation = "destination-over";
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, chart.width, chart.height);
        ctx.restore();
    },
};

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    whiteBackgroundPlugin
);

const BarChart = ({title, labels, datasets, options = {}}) => {
    const chartRef = useRef(null);

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        ...options,
    };

    const chartData = {
        labels,
        datasets: datasets,
    };

    const chartFilename = `${DateUtil.formatDateTimeForFilenames(
        new Date()
    )}_${title.toLowerCase().replace(" ", "_")}.png`;

    return (
        <Stack alignItems="flex-start" sx={{height: "400px", width: "700px", p: 3}}>
            <Bar options={chartOptions} data={chartData} ref={chartRef} />
            <DownloadChart chartRef={chartRef} filename={chartFilename} />
        </Stack>
    );
};

export default BarChart;
